import { render, staticRenderFns } from "./applyCourse.vue?vue&type=template&id=f039ddee&scoped=true"
import script from "./applyCourse.vue?vue&type=script&lang=js"
export * from "./applyCourse.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./applyCourse.vue?vue&type=style&index=1&id=f039ddee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039ddee",
  null
  
)

export default component.exports